import React, { useContext, useState } from "react";
import intl from "react-intl-universal";
import { mdiClose } from "@mdi/js";

import formatRest from "../../../rest/formatRest";
import commonUtils from "../../../script/utils/commonUtils";

import { useInput } from "../../hooks/useInput";
import { Dialog } from "../../containers/Dialog";
import { Button } from "../../components/Button";
import { Spacer } from "../../components/Spacer";
import { InputText } from "../../components/InputText";
import { FileSelect } from "../../components/FileSelect";
import { DialogBody } from "../../containers/DialogBody";
import { useValidation } from "../../hooks/useValidation";
import { DialogFooter } from "../../containers/DialogFooter";
import { ValidationContext } from "../../contexts/ValidationContext";

export const UploadDialog = props => {

    const validationContext = useContext(ValidationContext);

    const siteNum = useInput("siteNum");

    const [uploading, setUploading] = useState(false);

    useValidation(value => !commonUtils.isBlank(value), [siteNum]);

    const onClickChoseFile = async () => {
        const allValid = await validationContext.allValid();
        return allValid;
    };

    const onSelectFile = async event => {
        setUploading(true);
        const file = await commonUtils.readFile(event);
        const { result, name } = file;
        try {
            await formatRest.uploadFormat(name, siteNum.value, result);
        } finally {
            setUploading(false);
            props.onClose();
        }
    };

    return (
        <Dialog
            width="360px"
            title={intl.get("common.upload")}
            onClose={() => props.onClose()}>
            <DialogBody>
                <InputText {...siteNum.bind}
                    maxLength="15"
                    disabled={uploading}
                    title={intl.get("entry.siteNum")} />
            </DialogBody>
            <DialogFooter>
                <FileSelect
                    multiple
                    accept=".wwmobil, .bisx, .xml, .json"
                    value={intl.get("common.chooseFile")}
                    loading={uploading}
                    onClick={onClickChoseFile}
                    onSelect={event => onSelectFile(event)} />
                <Spacer variant="vertical" />
                <Button
                    svgIcon={mdiClose}
                    disabled={uploading}
                    onClick={() => props.onClose()}
                    value={intl.get("common.cancel")} />
            </DialogFooter>
        </Dialog>
    );
};